import {fromJS} from 'immutable';

const ENABLED = 'Enabled';
const DISABLED = 'Disabled';

const DISPLAY_NAMES = fromJS({
  [ENABLED]: 'Enabled',
  [DISABLED]: 'Disabled'
});

export default class UserStatus {
  static get enabled() {
    return ENABLED;
  }

  static get disabled() {
    return DISABLED;
  }

  static displayName(value) {
    return DISPLAY_NAMES.get(value);
  }
}



// WEBPACK FOOTER //
// ./app/features/users/UserStatus.js